import cn from 'classnames';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Button, StarRating } from 'ui';
// import Share from 'ui/components/icons/Share';
import { Typography } from 'ui';
import { ButtonVariants, Color, TypeScales } from 'ui/primitives';
// import EmiCalculator from '../../../popups/EmiCalculator';
import { ModelDetailType, VariantsListType } from 'src/modules/newCars/types';
import EmiOffer from '../../../EmiOffer';
// import fetchListingCityList from 'src/modules/newCars/services/fetchListingCityList';
import { useNativeAuth } from 'auth/hooks/useNativeAuth';
import { useSelector } from 'react-redux';
import fetchCityList from 'src/modules/newCars/services/getCityList';
import AllVariants from '../../../popups/AllVariants';
import TestDrivePopup from '../../../popups/TestDrivePopup';
import s from './Detail.module.scss';
import { getDefaultAttributes, trackEvent } from 'core-lib/utils/events';

export const Detail = ({
  data,
  showBottom = true,
  noOfRating,
  price,
  averageRating,
  setSelectedVariant,
  modelSlug,
  brandSlug,
  showButton = true,
}: {
  data: ModelDetailType;
  showBottom?: boolean;
  noOfRating: number;
  price: string;
  averageRating: number;
  setSelectedVariant?: (args: VariantsListType) => void;
  brandSlug: string;
  modelSlug: string;
  showButton?: boolean;
}) => {
  const [selectedCity, setSelectedCity] = useState({
    name: 'New Delhi',
    id: 4,
  });
  const [showCity, setShowCity] = useState(false);
  // const [showCalculator, setShowCalculator] = useState(false);
  const [showVariants, setShowVariants] = useState(false);
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [cityList, setCityList] = useState([]);
  const { isAuthenticated } = useSelector((state: any) => state?.auth);
  const { login } = useNativeAuth();

  const checkAuth = async (callback) => {
    if (isAuthenticated) {
      callback();
    } else {
      const res = await login();
      if (res) {
        callback();
      }
    }
  };

  async function fetchCities() {
    const { response }: any = await fetchCityList();
    if (response) {
      setCityList(response);
    }
  }

  const handleBookClick = () => {
    checkAuth(() => {
      setShowDetailPopup(true);
    });
    trackEvent({
      name: 'cta_clicked',
      defaultAttr: getDefaultAttributes(),
      attributes: {
        category: 'Services',
        subcategory: 'Test Drive',
        cta_name: 'book test drive',
        page_name: 'new_cars_web',
      },
    });
  };

  const router = useRouter();

  return (
    <div className={s.container}>
      <div className={s.root}>
        <div className={s.heading}>
          <div className={s.title}>
            <Typography
              label={`${data.hero.brandName} ${data.hero.modelName}`}
              variant={TypeScales.h1}
              renderAs="H2"
            />
            <div className={cn(s.share, 'cmn_only_desktop')}>
              <Button
                color={Color.interaction_button}
                label="See all variants"
                variant="ButtonLink"
                size="Small"
                onClick={() => setShowVariants((state) => !state)}
              />
            </div>
          </div>
          {noOfRating ? (
            <div className={s.rating}>
              <div className={s.star_count}>
                <StarRating
                  totalRating={5}
                  currentRating={averageRating}
                  size={20}
                />
                <Typography
                  label={`${noOfRating} ratings`}
                  variant={TypeScales.body_para_r}
                  className={s.count}
                  color={Color.text_subheading}
                />
              </div>
              <Typography
                label={`${noOfRating} review (Park+ verified owner)`}
                variant={TypeScales.body_para_r}
                color={Color.text_subheading}
                className={s.verifed_review}
              />
            </div>
          ) : (
            <div className={s.rating_placeholder} />
          )}
        </div>
        <div className={s.price_box}>
          <Typography
            label={price}
            variant={TypeScales.h2}
            className={s.price}
          />
          <div className={cn(s.desktop_btn, 'cmn_only_desktop')}>
            <Button
              label="Get on road price"
              variant={ButtonVariants.BlackLink}
              onClick={() =>
                router.push(
                  `/new-cars/${brandSlug}-car/${modelSlug}/price-in-${selectedCity?.name
                    .replaceAll(' ', '-')
                    .toLowerCase()}`
                )
              }
            />
          </div>
        </div>

        <div className={s.ex_showroom}>
          <Typography
            label="Ex-showroom price in New Delhi"
            variant={TypeScales.body_para_m}
            color={Color.text_label}
            className={s.text}
          />
          {/* <div className={s.location_btn}>
            <Button
              label={toPascalCase(selectedCity?.name)}
              variant={ButtonVariants.PrimaryNaked}
              size="Small"
              onClick={() => setShowCity(true)}
            />
          </div> */}
        </div>
        <div className={cn(s.mobile_btn, 'cmn_only_mobile')}>
          <Button
            label="Get on road price"
            variant={ButtonVariants.ButtonLink}
            onClick={() =>
              router.push(
                `/new-cars/${brandSlug}-car/${modelSlug}/price-in-${selectedCity?.name
                  ?.replaceAll(' ', '-')
                  .toLowerCase()}`
              )
            }
          />
        </div>
        {showButton && (
          <div className={s.offer_btn}>
            <Button
              label="Book Test Drive"
              fullwidth
              onClick={handleBookClick}
            />
          </div>
        )}
      </div>
      {showBottom && <EmiOffer price={data?.modelSeoData?.baseVariantPrice} handleGetEmiOffers={()=>setShowDetailPopup(true)}/>}
      {showVariants && (
        <AllVariants
          show
          onClose={() => setShowVariants(false)}
          variantsList={data?.variants}
          modelName={data?.hero?.modelName}
          modelImage={data?.hero?.image}
          setSelectedVariant={setSelectedVariant}
          brandSlug={brandSlug}
          modelSlug={modelSlug}
        />
      )}
      {/* {showCity && (
        <SelectCity
          cityList={cityList}
          show={showCity}
          onClose={() => setShowCity(false)}
          onSelect={(city) => {
            setSelectedCity(city);
            setShowCity(false);
          }}
          selectedCity={selectedCity}
        />
      )} */}
      {showDetailPopup && (
        <TestDrivePopup
          modelId={data?.modelId}
          show={showDetailPopup}
          onClose={() => {
            setShowDetailPopup(false);
          }}
        />
      )}
    </div>
  );
};
